module.exports = __webpack_public_path__ + "img/hx_9.e5fa1c65.png";